const desktopMediaQuery = window.matchMedia('(min-width: 989px)');

/**
 * Get document rect.
 *
 * @param   {NodeElement}  el
 * @return  {Object}
 */
function getDocumentRect(el) {
  const rect = el.getBoundingClientRect();
  const scrollY = window.scrollY;

  return {
    top: rect.top + scrollY,
    bottom: rect.bottom + scrollY,
    height: rect.height,
  };
}

/**
 * Set mask.
 *
 * @param   {NodeElement}  title
 * @param   {Number}  startPct
 * @param   {Number}  endPct
 * @return  {Void}
 */
function setMask(title, startPct, endPct) {
  title.style.setProperty('--mask-start', `${startPct}%`);
  title.style.setProperty('--mask-end', `${endPct}%`);
}

/**
 * Clear mask.
 *
 * @return  {Void}
 */
function clearMask(title) {
  setMask(title, 0, 0);
}

/**
 * Update title mask.
 *
 * @param   {NodeElement}  title
 * @param   {NodeElement}  image
 * @return  {Void}
 */
function updateTitleMask({ title, image }) {
  const text = getDocumentRect(title);
  const img = getDocumentRect(image);

  const overlapTop = Math.max(text.top, img.top);
  const overlapBottom = Math.min(text.bottom, img.bottom);

  if (overlapBottom <= overlapTop) {
    clearMask(title);
    return;
  }

  const start = overlapTop - text.top;
  const end = overlapBottom - text.top;

  const startPct = (start / text.height) * 100;
  const endPct = (end / text.height) * 100;

  setMask(title, startPct, endPct);
}

/**
 * Init hero title.
 *
 * @param   {NodeElement}  titleContainer
 * @return  {Void}
 */
function initHeroTitle(titleContainer) {
  const title = titleContainer.querySelector('h1');
  if (!title) {
    return;
  }

  title.classList.add('title--black');

  const clonedTitle = title.cloneNode(true);
  clonedTitle.classList.add('title--white');
  clonedTitle.classList.remove('title--black');
  titleContainer.appendChild(clonedTitle);

  const image = titleContainer.closest('.hero')?.querySelector('.js-hero-image');
  if (!image) {
    return;
  }

  const update = () => updateTitleMask({ title: clonedTitle, image });

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
}

//Init hero title color change
document.querySelectorAll('.js-hero-title').forEach(initHeroTitle);

document.querySelectorAll('.js-parallax').forEach((item) => {
  const parentSection = item.closest('section');
  const headerHeight = document.querySelector('header').offsetHeight;
  const sectionOffset = Math.max(item.scrollHeight - headerHeight, 0); // Adjust based on hero offset
  const initialOffset = parentSection.getBoundingClientRect().top + window.scrollY + sectionOffset;

  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const offset = (scrollTop - initialOffset) * 0.5;
    item.style.transform = `translateY(-${offset}px)`;
  });
});

// domcontent loaded
document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.hero').classList.add('loaded');
});
